import React, { JSX } from "react";
import MegaMenuHeader from "@app/layout/menus/MegaMenuHeader";
import MegaMenuLink from "@app/layout/menus/MegaMenuLink";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function OverviewsMenu(): JSX.Element {
  const featureFlags = React.useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Overviews" />
        <ul className="menu">
          <RoleRestricted allowedRoles={[Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER]}>
            <MegaMenuLink
              menuItem={MenuItemEnum.EnterpriseComplianceDashboard}
              faIcon="area-chart"
              to="/overviews/enterprise-compliance-dashboard"
              linkText="Enterprise Compliance Dashboard"
              onClick={(e) => { (e.target as HTMLElement).blur() }}
            />
          </RoleRestricted>

          <RoleRestricted allowedRoles={[Roles.COMPETITIVE_INSIGHTS_USER]}>
            <MegaMenuLink
              menuItem={MenuItemEnum.CompetitiveInsightsDashboard}
              faIcon="area-chart"
              to="/overviews/competitive-insights-dashboard"
              linkText="Competitive Insights Dashboard"
              onClick={(e) => { (e.target as HTMLElement).blur() }}
            />
          </RoleRestricted>

          {featureFlags.has(Features.NETWORK_PERFORMANCE_MARKET_EXPANSION) &&
            (
              <RoleRestricted allowedRoles={[Roles.NEW_MARKET_EXPANSION_USER]}>
                <MegaMenuLink
                  menuItem={MenuItemEnum.MarketExpansionDashboard}
                  faIcon="area-chart"
                  to="/overviews/market-expansion-dashboard"
                  linkText="New Market Expansion"
                  onClick={(e) => { (e.target as HTMLElement).blur() }}
                />
              </RoleRestricted>
            )
          }
        </ul>
      </li>
    </ul>
  );
}
